import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { SERVICE_AREAS, CONTACT } from "@/lib/siteData";
import { LANDING } from "@/constants/testIds";

export const ServiceAreas = () => {
  return (
    <section id="areas" className="relative py-12 lg:py-16 bg-slate-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-600">Popular Locations</span>
            <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-[1.05]">
              Popular locations <span className="water-text">we serve.</span>
            </h2>
            <p className="mt-5 text-lg text-slate-600 max-w-md">
              We test water samples from customers across Australia — drop yours at our Noosaville lab or post them in. Below are a few of the areas we commonly service.
            </p>

            <div className="mt-7 inline-flex items-start gap-3 rounded-2xl bg-white p-5 border border-slate-100 shadow-sm">
              <div className="w-10 h-10 rounded-xl bg-slate-900 flex items-center justify-center flex-shrink-0">
                <MapPin className="w-5 h-5 text-cyan-400" />
              </div>
              <div>
                <div className="text-[11px] uppercase tracking-[0.18em] font-bold text-cyan-600">Our Laboratory</div>
                <div className="font-display font-semibold text-slate-900 mt-0.5">{CONTACT.address}</div>
                <div className="text-sm text-slate-500 mt-1">Open Mon–Fri · {CONTACT.phone}</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="flex flex-wrap gap-2.5">
              {SERVICE_AREAS.map((area, i) => (
                <motion.span
                  key={area}
                  data-testid={LANDING.serviceAreaPill(area.toLowerCase())}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.03 }}
                  className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full bg-white border border-slate-200 hover:border-cyan-300 hover:bg-cyan-50/50 transition-all cursor-default"
                >
                  <MapPin className="w-3.5 h-3.5 text-cyan-500" />
                  <span className="text-sm font-medium text-slate-900">{area}</span>
                </motion.span>
              ))}
              <span className="inline-flex items-center px-4 py-2.5 rounded-full bg-slate-900 text-white text-sm font-semibold">
                + Australia-wide by post
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
